export {default} from './WalletCard';
